import Heading from 'components/universal/heading';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Product } from './product';
import cls from './shop.module.scss';

export const DownloadView = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'download',
    });

    const productsData = [
        {
            id: 1,
            title: "Instrukcja rejestracji listem ",
            description: "Instrukcja rejestracji listem",
            image_url: "/files/rejestracja.png",
            thumbnail_url: "/files/rejestracja.png",
            category_name: "",
            price: 0,
            hidden: false,
            url_to_download: '/files/instrukcja-rejestracji-listem.pdf',
        },
        {
            id: 2,
            title: "Instrukcja dla administratora szpitala jak zarządzać pracownikami",
            description: "Instrukcja dla administratora szpitala jak zarządzać pracownikami",
            image_url: "/files/zarzadzanie.pngf",
            thumbnail_url: "/files/zarzadzanie.png",
            category_name: "",
            price: 0,
            hidden: false,
            url_to_download: '/files/instrukcja-dla-administratora-szpitala-jak-zarzadzac-pracownikami.pdf',
        },
    ];


    return (
        <div className={cls.content}>
            <Heading
                className={cls.heading}
                headingLevel="h1"
                headingStyle="h2"
            >
                {t('title')}
            </Heading>
            <div className={cls.shop}>
                {productsData &&
                    productsData?.map?.((product, id) => (
                        <Fragment key={`${product?.id}-${id}`}>
                            <a className={cls.link} href={product.url_to_download} target='_blank'>
                                <Product
                                    product={product}
                                />
                            </a>
                        </Fragment>
                    ))}
            </div>
        </div>
    );
};
